export default __webpack_public_path__ + "static/media/img-slider-lh-job-sale-3.54ad59ae.png";